import React from 'react'
import { ActionButton } from './ActionButton'

function CheckAccentButton(props) {
  return <ActionButton iconType="check" {...props} />
}

export { CheckAccentButton }
